import React from 'react'
import NewHeadingSection from '../NewHeadingSection'
import PeaceOfMind from '../PeaceOfMind'


export default function WrapHeadingSection({ children, headTitle }) {
    return (
        <>

            <div className=' pt-10'>

                <NewHeadingSection
                    title={headTitle}
                />
                {children}

            </div>

        </>
    )
}
